<script lang="ts" setup>

  import { BngFavoriteCard } from '~/components/golf'

  const { favorites } = useFavorite()

  const dropdownDisplayed = ref(false)

</script>
<template>
  <div
    class="c-favorites-menu"
    @mouseleave="dropdownDisplayed = false"
  >
    <Button
      type="secondary"
      @mouseover="dropdownDisplayed = true"
    >
      <div class="button-content">
        <SvgIcon
          icon="favorite-stroke"
          :width="36"
          :height="24"
        />
        <span class="button-text">Favoris</span>
      </div>
    </Button>
    <NuxtLink
      to="/favorites"
      class="link"
    >
      <div class="button-content">
        <SvgIcon
          icon="favorite-stroke"
          :width="36"
          :height="24"
        />
        <span class="button-text">Favoris</span>
      </div>
    </NuxtLink>
    <div
      v-if="dropdownDisplayed"
      class="dropdown"
    >
      <div class="triangle" />
      <div class="content">
        <template v-if="favorites?.data?.length">
          <div class="cards">
            <BngFavoriteCard
              v-for="favoriteGolf in favorites.data"
              :key="favoriteGolf.id"
              :golf="favoriteGolf"
            />
          </div>
          <NuxtLink
            v-if="favorites?.data?.length"
            class="go-to-favorites"
            to="/favorites"
          >
            <span class="title">
              Tous mes favoris <SvgIcon
                icon="arrow-nav"
                :width="24"
                :height="20"
              /></span>
          </NuxtLink>
        </template>
        <template v-else>
          <span class="no-favorite"> Retrouvez ici tous vos golfs favoris ! </span>
        </template>
      </div>
    </div>
  </div>
</template>
<style scoped>
.c-favorites-menu {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;

  .link {
    justify-content: center;
    padding: 0.75em 0.5em 0.5em;
    background-color: var(--color-secondary);
    color: white;
  }

  .c-button {
    display: none;
  }

  .c-button,
  .link {
    width: 4em;
    flex: 1 1 auto;
    align-items: center;
    padding-bottom: 0;

    .button-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .c-icon {
        margin-bottom: 0.25em;
      }

      .button-text {
        color: white;
        font-family: Open-Sans, sans-serif;
        font-size: 0.75em;
        font-weight: 600;
      }
    }
  }

  .dropdown {
    position: absolute;
    z-index: 1;
    top: calc(100% - 6px);
    right: -1em;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .triangle {
      position: relative;
      z-index: 2;
      right: calc(3em - 8px);
      width: 16px;
      border-width: 0 8px 6px;
      border-style: solid;
      border-right-color: transparent;
      border-bottom-color: white;
      border-left-color: transparent;
    }

    .content {
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      padding: 2em;
      border-radius: 0 0 0.25em 0.25em;
      background-color: white;
      box-shadow: 0 0 25px 0 rgb(0 0 0 / 15%);

      .no-favorite {
        color: var(--color-secondary);
        font-family: Bariol, sans-serif;
        font-size: 1.5em;
        font-weight: bold;
        white-space: nowrap;
      }

      .cards {
        max-height: 200px;
        overflow-y: auto;

        .c-favorite-golf {
          width: 600px;
        }
      }
    }

    .go-to-favorites {
      display: flex;
      height: 100%;
      flex: 0 0 auto;
      flex-direction: row;
      align-items: center;
      align-self: flex-end;
      justify-content: space-between;
      padding: 0.75em 1em;
      margin-top: 1em;
      background-color: var(--color-primary);
      cursor: pointer;
      transition: opacity 0.25s ease-out;

      &:hover {
        .title {
          .c-icon {
            margin-right: 0;
          }
        }
      }

      .title {
        display: flex;
        flex: 1 1 auto;
        flex-direction: row;
        justify-content: space-between;
        color: var(--color-secondary);
        font-family: Bariol, sans-serif;
        font-size: 1.375em;
        font-weight: bold;
        letter-spacing: 1.5px;
        text-transform: uppercase;

        .c-icon {
          margin-right: 0.25em;
          transform: rotate(-0.25turn);
          transition: margin-right ease-out 0.25s;
        }
      }
    }
  }

  @media screen and (width >= 800px) {
    .link {
      display: none;
    }

    .c-button {
      display: inherit;
    }

    .dropdown {
      display: flex;
    }
  }

  @media screen and (width >= 1024px) {
    .dropdown {
      top: calc(100% - 10px);

      .triangle {
        right: calc(3em - 12px);
        width: 24px;
        border-width: 0 12px 10px;
      }
    }
  }
}
</style>
